export enum LocalNotificationKeys {
    MESSAGE = 'notification_msg',
}
